import Form from 'client/javascript/lead_form';
import { setupMarketSelectField } from 'client/javascript/market_select_field';
import { setupPhoneInput } from 'client/javascript/phone';
import { showElements, hideElements } from 'client/javascript/util/dom_utils';
import { submitLead } from 'client/javascript/submit_lead';
import { sha256 } from 'client/javascript/util/krux';
import { sendLeadFormHeapEvents } from 'client/javascript/form_analytics';
import { getGoogleAnalyticsData } from 'client/javascript/analytics';
import { logError } from 'client/javascript/util/logger';

const errorsContainer = {
  selector: '#dynamic-submit-lead-form-error-message',
  show() {
    return showElements(this.selector);
  },
  hide() {
    return hideElements(this.selector);
  }
};

function initializeFormFields(leadForm) {
  const fieldInitializers = {
    '#dynamic-form-location-select': () => setupMarketSelectField('dynamic-form-location-select'),
    '#dynamic-form-phone': () => setupPhoneInput(leadForm.form.querySelector('#dynamic-form-phone'))
  };

  Object.keys(fieldInitializers).forEach(selector => {
    if (leadForm.form.querySelector(selector)) {
      fieldInitializers[selector]();
    }
  });
}

export function setUpLeadForm() {
  const leadFormContainer = document.getElementById('dynamic-lead-form');
  if (leadFormContainer) {
    const leadForm = new Form(leadFormContainer, formSubmitHandler);
    initializeFormFields(leadForm);
  }
}

async function formSubmitHandler(event, values) {
  if (event) {
    event.preventDefault();
  }

  errorsContainer.hide();

  try {
    const submitLeadData = await buildLeadData(values);
    await submitLead(submitLeadData, values.leadSourceDetail);
    await trackFormSubmission(values);
    showThankYou();
  } catch (error) {
    logError(`Dynamic Lead Form submission error, path ${document.location.href}`, error);
    errorsContainer.show();
  }
}

async function buildLeadData(leadFormData) {
  const leadData = {
    submission_type: 'lead',
    lead_source: leadFormData.leadSource,
    lead_source_subtype: leadFormData.leadSourceSubtype,
    google_analytics: null,
    ...(leadFormData.company_name && { company_name: leadFormData.company_name }),
    ...(leadFormData.desks_interested_min && { desks_interested_min: leadFormData.desks_interested_min }),
    ...(leadFormData.company_size && { company_size: leadFormData.company_size }),
    ...(leadFormData.contact_name && { contact_name: leadFormData.contact_name }),
    ...(leadFormData.phone && { phone: leadFormData.phone }),
    ...(leadFormData.notes && { notes: leadFormData.notes }),
    marketing_consent: leadFormData.marketing_consent
  };

  leadData.google_analytics = await getGoogleAnalyticsData();
  delete leadData.google_analytics.gauserid; // removed by request of Billy Lam

  if (leadFormData.email) {
    leadData.email = leadFormData.email;
    leadData.email_sha256 = await sha256(leadFormData.email);
  }

  if (leadFormData.market) {
    leadData.city = leadFormData.market;
    leadData.interests = { market_ids: [leadFormData.market] };
  }

  return leadData;
}

function trackFormSubmission(leadFormData) {
  const copyLeadFormData = { ...leadFormData };
  delete copyLeadFormData.leadSource;
  delete copyLeadFormData.leadSourceSubtype;
  delete copyLeadFormData.leadSourceDetail;
  return sendLeadFormHeapEvents(copyLeadFormData, leadFormData.leadSourceDetail, leadFormData.leadSourceSubtype);
}

function showThankYou() {
  hideElements('#js-dynamic-form-container');
  showElements('#js-dynamic-form-lead-success');
}
